import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const ORDERS = gql`
  query Orders($filter: OrderFilter, $sort: OrderSort) {
    orders(filter: $filter, sort: $sort) {
      count
      data {
        orderNumber
        id
        deliveryType
        orderItemCount
        deliveryPartner {
          firstName
          lastName
          id
          userNumber
        }
        user {
          firstName
          lastName
          id
          userNumber
          pincode {
            pincode
          }
        }
        createdAt
        expectedDeliveryTime
        status
        cancellationData {
          additionalComment
          reason
        }
      }
    }
  }
`;

export const ORDER_ITEMS = gql`
  query OrderItems($where: OrderUniqueInput) {
    orderItems(where: $where) {
      count
      data {
        isPreOrder
        id
        transferOrders {
          status
        }
        toy {
          id
          toyNumber
          name
          category {
            name
          }
          ageGroup {
            minAge
            maxAge
          }
        }
        status
      }
    }
  }
`;

export const PINCODES = gql`
  query Pincodes($filter: PincodesFilter, $sort: PincodesSort) {
    pincodes(filter: $filter, sort: $sort) {
      count
      data {
        pincode
        id
      }
    }
  }
`;

export const USERS_BY_LIBRARY = gql`
  query UsersByLibrary(
    $filter: UsersByLibraryFilter
    $sort: UsersSort
    $libraryId: ID!
  ) {
    usersByLibrary(filter: $filter, sort: $sort, libraryId: $libraryId) {
      count
      data {
        id
        contactNo
        email
        roles
        createdAt
        isActive
        isArchived
        firstName
        lastName
        agencyName
        vehicleNumber
        userNumber
        latLong {
          coordinates
          type
        }
        subscription {
          subscriptionPlan {
            type
            name
          }
        }
        pincode {
          library {
            id
            name
            libraryNumber
          }
        }
        userLibraries {
          id
          library {
            name
            id
            libraryNumber
          }
          type
        }
        bankAccounts {
          accountNumber
          holderName
          ifsc
          isDefault
          id
          upiId
          type
        }
      }
    }
  }
`;
